'use client';

import { PricingSection } from '~/components/pricing/pricing-section';
import { useSectionVisibility } from '~/lib/contexts/section-visibility-context';
import { getPricingVisibility } from '~/lib/section-visibility';

export function HomePricingSection() {
  const visibility = useSectionVisibility();

  return (
    <PricingSection
      variant="landing"
      title="Cennik"
      visibility={getPricingVisibility(visibility, 'main')}
    />
  );
}
